import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MUITable from "../../../../Common/MUITable";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import useGrievanceReportStore from "../../GrievanceDetailedReport/store/grievanceReportStore";
import isGHMC from "../../../../Common/helper/helpar";
import { MSWManagementVehiclesFilter } from "./MSWManagementVehiclesFilter";
import { MSWManagementVehiclesExport } from "./MSWManagementVehiclesExport";
import { MSWManagementVehiclesInnerExport } from "./MSWManagementVehiclesInnerExport";
export const MSWManagementVehiclesOnRoadInnerReport = () => {
    const {
        grievanceReportData,
        loading,
        grievanceItemsDropedownList,
        fetchgrievanceDetailedReport,
        grievanceItemList,
        setSelectedComplaintNo,
        selectComplaintNo,
        setStatus,
        selectedStatus,
        setSelectedIEName,
        selectIEName } = useGrievanceReportStore();
    const isProd = isGHMC()
    const [modalShow, setModalShow] = useState(false);
    const [selectedGrievanceData, setSelectedGrievanceData] = useState(null);
    console.log(grievanceItemsDropedownList)

    useEffect(() => {
        // Initial fetch without filters
        fetchgrievanceDetailedReport();
    }, []);

    // Function to fetch data with filters when clicking search
    const handleSearch = () => {
        fetchgrievanceDetailedReport({
            complaintNo: selectComplaintNo,
            status: selectedStatus,
            ieEngineerId: selectIEName

        });
    };

    const grievanceReportHeaderColumns = [
        { label: "Zone Name", field: "complaintNo" },
        { label: "Circle Name", field: "kpiCategoryName" },

        {
            // name: <>Cleared GVPs<br/>Points</> ,
            label: "Alloted Vehicles",
            field: "ieEngineerName"
        },
     
        { label: "Deployed Vehicles", field: "description" },
        { label: "Deployment %", field: "description" },
        { label: "HKL Vehicle Capacity", field: "description" },

    ];

    return (
        <div style={{ width: "100%" }}>
            <div className="content">
                <div className="page-content">
                  <div className="top-header page-title">
                    <span>Detailed Vehicle Deployment Data Report</span>
                  </div>
                    <MSWManagementVehiclesInnerExport/>
                    {/* Data Table Section */}
                    <div className="card mt-3">
                        <div className="card-body">
                            {/* Filter & Search Section */}

                                <MUITable loading={loading}
                                    needSRNumber
                                    columns={grievanceReportHeaderColumns}
                                    // rows={grievanceReportData}
                                    tableHeight={500}
                                />
                        </div>



                    </div>
                </div>
            </div>
        </div>
    );
};
